import { NavLink, Link } from "react-router-dom";
import { RiHomeFill } from "react-icons/ri";
import { BsInfoSquareFill } from "react-icons/bs";

import logo from "../assets/favicon.png";
import { categories } from "../utils/data";

const isNotActiveStyle =
  "flex items-center px-5 gap-3 text-grey-500 font-normal hover:text-black transition-all duration-200 ease-in-out capitalize";

const isActiveStyle =
  "flex items-center px-3 gap-3 font-bold border-r-2 border-black transition-all duration-200 ease-in-out capitalize";

const Sidebar = ({ user, closeToggle }) => {
  const handleCloseSidebar = () => {
    if (closeToggle) {
      closeToggle(false);
    }
  };

  return (
    <div className="flex flex-col justify-between bg-white h-full overflow-y-scroll min-w-210 ">
      <div className="flex flex-col ">
        <Link
          to="/"
          className="flex px-3 gap-2 my-6 pt-1 w-190 items-center"
          onClick={handleCloseSidebar}
        >
          <img src={logo} alt="logo" className="w-10" />
          <p className="font-medium">Web Dev Share</p>
        </Link>
        <div className="flex flex-col gap-5">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? isActiveStyle : isNotActiveStyle
            }
            onClick={handleCloseSidebar}
          >
            <RiHomeFill />
            Home
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? isActiveStyle : isNotActiveStyle
            }
            onClick={handleCloseSidebar}
          >
            <BsInfoSquareFill />
            About
          </NavLink>
          <h3 className="mt-2 px-5 text-base font-medium 2xl:text-xl">
            Discover Categories
          </h3>
          {categories.slice(0, categories.length).map((category) => (
            <NavLink
              to={`/category/${category.name}`}
              className={({ isActive }) =>
                isActive ? isActiveStyle : isNotActiveStyle
              }
              onClick={handleCloseSidebar}
              key={category.name}
            >
              <img
                src={category.image}
                className=" w-8 h-8 rounded-full shadow-sm object-cover object-center  "
                alt="category images"
              />
              {category.name}
            </NavLink>
          ))}
        </div>
      </div>

      {user && (
        <Link
          to={`/user-profile/${user._id}`}
          className="flex my-5 mb-3 gap-2 p-2 items-center bg-white mx-3"
        >
          <img
            src={user.image}
            alt={user.userName}
            className="w-10 h-10 rounded-full"
            onClick={handleCloseSidebar}
          />
          <p className="font-semibold">{user.userName}</p>
        </Link>
      )}
    </div>
  );
};

export default Sidebar;
